import React from "react";
import PropTypes from "prop-types";

import { useFeatures } from "components/FeatureFlag";

import { DeletedCRMContactWarning } from "./DeletedCRMContactWarning";

export function FeatureFlaggedCRMContactWarning({ show, ...props }) {
  const ff = useFeatures("merge-client-card");

  return (
    <DeletedCRMContactWarning {...props} show={ff?.visualIndicator && show} />
  );
}

FeatureFlaggedCRMContactWarning.propTypes = {
  show: PropTypes.bool,
};

FeatureFlaggedCRMContactWarning.defaultProps = {
  show: false,
};

export default FeatureFlaggedCRMContactWarning;
